<form [formGroup]="form" (ngSubmit)="accept()" novalidate>
    <div class="modal-header">
        <h4 class="modal-title">Detalle Pregunta</h4>
        <button type="button" class="close" aria-label="Close" (click)="dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="form-group col-md-12">
                <label for="pregunta">Pregunta</label>
                <input type="text" class="form-control" id="pregunta" formControlName="pregunta"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.pregunta.errors }">
                <div *ngIf="submitted && form.controls.pregunta.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.pregunta.errors.required">Campo requerido
                    </div>
                </div>
            </div>

            <div class="form-group col-md-12">
                <label for="descripcion">Descripción</label>
                <textarea rows="5" class="form-control" id="descripcion" formControlName="descripcion"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.descripcion.errors }">
                </textarea>
                <div *ngIf="submitted && form.controls.descripcion.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.descripcion.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-6">
                <label for="opcionesMinimas">Elegir entre</label>
                <select class="form-control" id="opcionesMinimas" formControlName="opcionesMinimas"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.opcionesMinimas.errors }">
                    <div *ngIf="submitted && form.controls.opcionesMinimas.errors" class="invalid-feedback">
                        <div *ngIf="form.controls.opcionesMinimas.errors.required">Campo requerido
                        </div>
                    </div>
                    <option *ngFor="let item of comboOpcion1" [ngValue]="item">{{item.nombre}}
                    </option>
                </select>
            </div>

            <div class="form-group col-md-6">
                <label for="opcionesMaximas">y</label>
                <select class="form-control" id="opcionesMaximas" formControlName="opcionesMaximas"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.opcionesMaximas.errors }">
                    <div *ngIf="submitted && form.controls.opcionesMaximas.errors" class="invalid-feedback">
                        <div *ngIf="form.controls.opcionesMaximas.errors.required">Campo requerido
                        </div>
                    </div>
                    <option *ngFor="let item of comboOpcion2" [ngValue]="item">{{item.nombre}}
                    </option>
                </select>
            </div>

            <div class="form-group col-md-12">
                <div class="icheck-primary d-inline">
                    <input type="checkbox" class="form-check-input" id="votoNulo" formControlName="votoNulo">
                    <label for="votoNulo">Permitir voto nulo</label>
                </div>
            </div>

            <div class="modal-footer full-width col-md-12">
                <div class="col-md-12 text-center">
                    <button type="button" class="btn btn-danger btn-fidelis col-md-4" (click)="dismiss()">
                        <i class="fa fa-times-circle"></i>
                        Cancelar
                    </button>
                    <button type="submit" class="btn btn-success btn-fidelis col-md-4">
                        <i class="fa fa-check-circle"></i>
                        Aceptar
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>